<template>
  <div>
    <b-row>
      <b-col v-if="namecam">
        <b-col
          v-for="(link, index) in rtsp.slice(0,1)"
          :key="index"
          class="mb-1 ml-1"
          align-self="baseline"
          lg="12"
          md="12"
        >
          <div>
            <b-img
              height="22"
              src="@/assets/images/icons/cctv.svg"
              class="mb-1 mr-1"
            />
            <span
              class="text1"
              style="font-size: 18px;"
            >กล้องวงจรปิด</span>

          </div>
          <div>
            <video
              :id="'video' + index"
              style="width:100%; height:auto; flex-direction: row;"
              muted
              autoplay
              playsinline
            />
          </div>
          <div>
            <h1 class="text2">
              ตำแหน่ง: {{ namecam }}
            </h1>
          </div>
        </b-col>
      </b-col>

      <b-col
        v-else
        align-self="baseline"
        lg="6"
        md="6"
      >
        <div>
          <b-img
            height="22"
            src="@/assets/images/icons/cctv.svg"
            class="mb-1 ml-1"
          />
          <span
            class="text1 ml-1"
            style="font-size: 18px;"
          >กล้องวงจรปิด</span>
          <div>
            <center>
              <img
                height="200px"
                src="@/assets/images/icons/markeranalytic120/Nocctv.svg"
              >
            </center>
          </div>
        </div>
      </b-col>

      <b-col
        cols="6"
      >
        <!-- <div>
          <b-img
            height="22"
            src="@/assets/images/icons/markeranalytic120/iconimage.svg"
          /> -->
        <div>
          <div
            v-if="img"
          >
            <div class="mr-1">
              <h1
                style="font-size: 18px;"
                class="ml-1"
              >
                ภาพการวิเคราะห์จราจรล่าสุด (กล้อง {{ camid }})
              </h1>
            </div>
          </div>
          <div
            v-else
          >
            <div>
              <h1
                style="font-size: 18px;"
                class="ml-1"
              >
                ภาพการวิเคราะห์จราจรล่าสุด
              </h1>
            </div>
          </div>
        </div>
        <!-- </div> -->

        <div>
          <div v-if="img">
            <!-- <span class="text1">ภาพการวิเคราะห์จราจรล่าสุด</span> -->
            <b-img
              :src="img"
              style="width:95%; height:auto; flex-direction: row;"
            />
          </div>
          <div
            v-else
          >
            <center>
              <img
                height="210px"
                src="@/assets/images/icons/markeranalytic120/Noimage.svg"
              >
            </center>
          </div>
        </div>

        <div>
          <div
            v-if="img"
          >
            <div>
              <!-- <h1 class="text2 mt-1">จุดติดตั้ง: {{ camdesc }}</h1> -->
              <h1 class="text2">
                {{ date }} ({{ detection }})
              </h1>
            </div>
          </div>
          <div
            v-else
          >
            <div />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },

  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      detail: '',
      img: '',
      rtsp: [],
      namecam: '',
      camid: '',
      camdesc: '',
      detection: '',
      date: '',
      type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.type = this.$route.query.type
    this.for()
    this.getLastImg()
    this.getCamAnalytic()
    this.getEventImgAnalytic()
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())

    this.interval = setInterval(() => {
      this.for()
      this.getCamAnalytic()
      this.getEventImgAnalytic()
    }, 300000)
  },
  methods: {
    getCamAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCamAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCamAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getLastImg() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getLastImgAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.img = response.data[0].FilePath
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getLastImgAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.img = response.data[0].FilePath
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    stream1(value) {
      setTimeout(() => {
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },
    for() {
      setTimeout(() => this.rtsp.forEach((value, i) => {
        this.stream(value.RTSP_URL, i)
      }), 500)
    },
    stream(value, i) {
      console.log(value)
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#video${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },

    getEventImgAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getEventImgAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.camid = response.data[0].CAMID
            this.camdesc = response.data[0].Camera_Desc
            this.detection = response.data[0].Detection_Type
            this.date = response.data[0].DATE_TIME
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getEventImgAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.camid = response.data[0].CAMID
            this.camdesc = response.data[0].Camera_Desc
            this.detection = response.data[0].Detection_Type
            this.date = response.data[0].DATE_TIME
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  // .vue2leaflet-map {
  //     &.leaflet-container{
  //     position: absolute;
  //     width: 100%;
  //     height: 638px;
  //     }
  // }
.text1 {
font-size: 22px;
color: #ffffff;
// font-weight: bold;
}
.text2 {
font-size: 14px;
color: #ffffff;
text-align: center;
// font-weight: bold;
}

.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(2,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}

</style>
